module.exports = __webpack_public_path__ + "img/preview-circle.1becd7c7.png";